
export const GET_ADDONS_SUCCESS = "GET_ADDONS_SUCCESS";
export const GET_ADDONS_FAILURE = "GET_ADDONS_FAILURE";
export const GET_ADDONS_STARTED = "GET_ADDONS_STARTED";